/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import * as Yup from "yup";
import { useFormik } from 'formik';

import { useToast } from '../../../Toats'
import { KTSVG } from '../../../../../../_metronic/helpers'
import { LoadingSpan } from '../../../Loadings/loadingSpan'
import { postPrognosisOne, putPlantOne, putPrognosisOne } from '../../../../../services/plantsService';
import useSize from '../../../../../hooks/useSize';
import { useAuth } from '../../../../../modules/auth';
import { ModalExportDataPrognosis } from '../ModalUpdatePlant/components/modalExportDataPrognosis';

type Props = {
    id: string;
    data: any;
    show: boolean;
    handleClose: () => void
}

const validationSchema = Yup.object().shape({
  annual_generation_forecast: Yup.number(),

  prog_abr: Yup.number(),
  prog_ago: Yup.number(),
  prog_dez: Yup.number(),
  prog_fev: Yup.number(),
  prog_jan: Yup.number(),
  prog_jul: Yup.number(),
  prog_jun: Yup.number(),
  prog_mar: Yup.number(),
  prog_may: Yup.number(),
  prog_nov: Yup.number(),
  prog_oct: Yup.number(),
  prog_sep: Yup.number(),
});

const MONTHS_LABELS: {key: string, label: string}[] = [
  {key: 'prog_jan', label: 'Janeiro'},
  {key: 'prog_fev', label: 'Fevereiro'},
  {key: 'prog_mar', label: 'Março'},
  {key: 'prog_abr', label: 'Abril'},
  {key: 'prog_may', label: 'Maio'},
  {key: 'prog_jun', label: 'Junho'},
  {key: 'prog_jul', label: 'Julho'},
  {key: 'prog_ago', label: 'Agosto'},
  {key: 'prog_sep', label: 'Setembro'},
  {key: 'prog_oct', label: 'Outubro'},
  {key: 'prog_nov', label: 'Novembro'},
  {key: 'prog_dez', label: 'Dezembro'},
]

const buildValues = (data: any) => ({
  annual_generation_forecast: data && data.annual_generation_forecast ? data.annual_generation_forecast : 0,
  plano: data && data.plano ? data.plano : '',

  prog_abr: data && data.prognosis && data.prognosis.prog_abr ? data.prognosis.prog_abr : 0,
  prog_ago: data && data.prognosis && data.prognosis.prog_ago ? data.prognosis.prog_ago : 0,
  prog_dez: data && data.prognosis && data.prognosis.prog_dez ? data.prognosis.prog_dez : 0,
  prog_fev: data && data.prognosis && data.prognosis.prog_fev ? data.prognosis.prog_fev : 0,
  prog_jan: data && data.prognosis && data.prognosis.prog_jan ? data.prognosis.prog_jan : 0,
  prog_jul: data && data.prognosis && data.prognosis.prog_jul ? data.prognosis.prog_jul : 0,
  prog_jun: data && data.prognosis && data.prognosis.prog_jun ? data.prognosis.prog_jun : 0,
  prog_mar: data && data.prognosis && data.prognosis.prog_mar ? data.prognosis.prog_mar : 0,
  prog_may: data && data.prognosis && data.prognosis.prog_may ? data.prognosis.prog_may : 0,
  prog_nov: data && data.prognosis && data.prognosis.prog_nov ? data.prognosis.prog_nov : 0,
  prog_oct: data && data.prognosis && data.prognosis.prog_oct ? data.prognosis.prog_oct : 0,
  prog_sep: data && data.prognosis && data.prognosis.prog_sep ? data.prognosis.prog_sep : 0,
})

const modalsRoot = document.getElementById('root-modals') || document.body

const ModalUpdatePrognosisPlant = ({show, handleClose, id, data}: Props) => {

  const { toggleToast } = useToast();
  const {currentUser} = useAuth()
  const [loading, setLoading] = useState(false)
  const [showCreateAppModalExport, setShowCreateAppModalExport] = useState<boolean>(false)
  const [initialValues] = useState<any>(buildValues(data))
  const {width} = useSize()

  const closed = () => {
    handleClose()
  }

  const updatePrognosisSubmit = async () => {
    try {
      setLoading(true)

      const bodyPlant = {
        annual_generation_forecast: formik.values.annual_generation_forecast,
        plano: formik.values.plano ? formik.values.plano : null,
      };

      const bodyPrognosis = {
        prog_abr: formik.values.prog_abr ? formik.values.prog_abr : 0,
        prog_ago: formik.values.prog_ago ? formik.values.prog_ago : 0,
        prog_dez: formik.values.prog_dez ? formik.values.prog_dez : 0,
        prog_fev: formik.values.prog_fev ? formik.values.prog_fev : 0,
        prog_jan: formik.values.prog_jan ? formik.values.prog_jan : 0,
        prog_jul: formik.values.prog_jul ? formik.values.prog_jul : 0,
        prog_jun: formik.values.prog_jun ? formik.values.prog_jun : 0,
        prog_mar: formik.values.prog_mar ? formik.values.prog_mar : 0,
        prog_may: formik.values.prog_may ? formik.values.prog_may : 0,
        prog_nov: formik.values.prog_nov ? formik.values.prog_nov : 0,
        prog_oct: formik.values.prog_oct ? formik.values.prog_oct : 0,
        prog_sep: formik.values.prog_sep ? formik.values.prog_sep : 0,
        idPlant: id ? id : ""
      }

      await putPlantOne(id, bodyPlant);

      if(data && data.prognosis){
        await putPrognosisOne(data.prognosis.id, bodyPrognosis);
      }else{
        await postPrognosisOne(bodyPrognosis)
      }

      toggleToast("Sucesso ao atualizar o prognóstico da usina. ", "success")

    } catch (error) {
      console.log(error)
      toggleToast("Erro ao atualizar o prognóstico da usina. ", "error")
    }finally{
      setLoading(false)
      closed()
    }
  }

  const submit = () => {
    updatePrognosisSubmit()
  }

  const dividerValues = () => {
    const value = formik.values.annual_generation_forecast;
    if(value){
      const value_mes = Number((value/12).toFixed(2));

      formik.setValues({
        ...formik.values,
        prog_abr: value_mes,
        prog_ago: value_mes,
        prog_dez: value_mes,
        prog_fev: value_mes,
        prog_jan: value_mes,
        prog_jul: value_mes,
        prog_jun: value_mes,
        prog_mar: value_mes,
        prog_may: value_mes,
        prog_nov: value_mes,
        prog_oct: value_mes,
        prog_sep: value_mes
      })
    }
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnChange: false,
    onSubmit: submit,
  });

  const blockedByPlan = data && data.plano && data.plano !== "PREMIUM" && data.plano !== "STARTER" ? true : false

  useEffect(() => {
    formik.setValues(buildValues(data))
  }, [show]);

  useEffect(() => {
    const allFilled = MONTHS_LABELS.every(({key}) => (
      formik.values[key] !== undefined && formik.values[key] !== '' && formik.values[key] !== null
    ))

    if(allFilled){
      const total = MONTHS_LABELS.reduce((acc, {key}) => acc + Number(formik.values[key]), 0)
      formik.setValues({...formik.values, annual_generation_forecast: Number(total.toFixed(2))})
    }
  }, [
    formik.values.prog_abr,
    formik.values.prog_ago,
    formik.values.prog_dez,
    formik.values.prog_fev,
    formik.values.prog_jan,
    formik.values.prog_jul,
    formik.values.prog_jun,
    formik.values.prog_mar,
    formik.values.prog_may,
    formik.values.prog_nov,
    formik.values.prog_oct,
    formik.values.prog_sep,
  ]);

  return createPortal(
    <Modal
      id='kt_modal_update_prognosis_plant'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName={
        width < 1200 ? 'modal-dialog modal-dialog-centered modal-fullscreen-xxl-down p-5 h-auto'
        : 'modal-dialog modal-dialog-centered modal-xl'
      }
      className='modal-stacked'
      backdropClassName='modal-backdrop-stacked'
      show={show}
      onHide={closed}
      backdrop={true}
    >
      <div className='modal-header'>
        <h3 className='d-flex flex-column align-items-start mb-0'>
          <span className='card-label fw-bold fs-3 mb-1'>
            Prognóstico da Usina {" - "}{data && data.name ? data.name : "Não identificado"}
          </span>
          <span className='text-muted mt-1 fw-semibold fs-7'>
            Informe a geração prevista de cada mês desta usina
          </span>
        </h3>

        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={closed}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
        {blockedByPlan && (
          <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed p-5 mb-5'>
            <KTSVG
              path='/media/icons/duotune/general/gen044.svg'
              className='svg-icon-2tx svg-icon-warning me-4'
            />
            <div className='fw-semibold'>
              <div className='fs-6 text-gray-800 mb-1'>Edição de prognóstico bloqueada</div>
              <div className='text-muted fs-7'>
                Esta usina está no plano {data?.plano === 'BASICA' ? 'BÁSICA' : (data?.plano || 'atual')}.
                A edição do prognóstico está disponível apenas nos planos PREMIUM e STARTER.
                Altere o plano abaixo e clique em Atualizar para salvar. Os campos serão liberados após a alteração ser gravada.
              </div>
            </div>
          </div>
        )}

        <div className='fv-row' style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <label className='d-flex align-items-center fs-6 fw-semibold mb-2' style={{flex: width < 1200 ? 1 : 5}}>
              <span>Geração Anual Prevista (KWh)</span>
              <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Geração anual prevista da usina'
              ></i>
          </label>
          <div style={{flex: 1, display: 'flex', gap: '0.7rem', alignItems: 'center'}}>
            <input
                type='number'
                disabled={blockedByPlan}
                className='form-control form-control-lg'
                name='annual_generation_forecast'
                placeholder=''
                value={formik.values.annual_generation_forecast}
                onChange={formik.handleChange("annual_generation_forecast")}
            />
            <button
                type='button'
                disabled={blockedByPlan}
                className='btn btn-sm btn-primary'
                onClick={dividerValues}
            >
                Aplicar
            </button>

            <button
              type='button'
              className='btn btn-sm btn-icon btn-active-color-primary'
              onClick={() => {setShowCreateAppModalExport(true)}}
              disabled={blockedByPlan}
            >
              <div>
                <KTSVG className='svg-icon-2x' path='/media/icons/duotune/arrows/arr078.svg' />
              </div>
            </button>
          </div>
        </div>

        <div className='fv-row mt-5' style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
          {[0, 3, 6, 9].map((start) => (
            <div key={start} style={{display: 'flex', gap: '1rem', flexWrap: width < 1200 ? 'wrap' : 'nowrap'}}>
              {MONTHS_LABELS.slice(start, start + 3).map(({key, label}) => (
                <div key={key} style={{display: 'flex', gap: '0.5rem', flex: '1'}}>
                  <label style={{width: '11rem'}} className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                      <span>{label}</span>
                  </label>
                  <input
                      type='number'
                      disabled={blockedByPlan}
                      className='form-control form-control-lg'
                      name={key}
                      placeholder=''
                      value={formik.values[key]}
                      onChange={formik.handleChange(key)}
                      onBlur={(e) => {
                        if (e.target.value === "") {
                          formik.setFieldValue(key, 0);
                        }
                      }}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>

        <div className='separator my-8'></div>

        <div className='fv-row' style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <label className='d-flex align-items-center fs-6 fw-semibold mb-2' style={{flex: width < 1200 ? 1 : 2}}>
              <span>Plano da usina</span>
              <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='O plano da usina define se o prognóstico pode ser editado'
              ></i>
          </label>
          <div style={{flex: width < 1200 ? 1 : 3}}>
            <select
              className='form-select form-select-lg form-select-solid'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              value={formik.values.plano}
              onChange={(e) => {
                formik.setValues({...formik.values, plano: e.target.value})
              }}
            >
              <option value={''} disabled>Selecione um plano</option>
              {
                (
                  formik.values.plano === 'PREMIUM'
                  || (
                    currentUser
                    && currentUser.companies
                    && currentUser.companies.length > 0
                    && currentUser.companies[0].planosCompany
                    && currentUser.companies[0].planosCompany.qtd_plants_plano > 0
                  )
                )
                && (
                  <option value={'PREMIUM'}>PREMIUM</option>
                )
              }
              {
                (
                  formik.values.plano === 'STARTER'
                  || (
                    currentUser
                    && currentUser.companies
                    && currentUser.companies.length > 0
                    && currentUser.companies[0].planosCompany
                    && currentUser.companies[0].planosCompany.qtd_plants_plano_starter > 0
                  )
                )
                && (
                  <option value={'STARTER'}>STARTER</option>
                )
              }
              {
                (
                  formik.values.plano === 'BASICA'
                  || (
                    currentUser
                    && currentUser.companies
                    && currentUser.companies.length > 0
                    && currentUser.companies[0].planosCompany
                    && currentUser.companies[0].planosCompany.qtd_plants_gratuita > 0
                  )
                )
                && (
                  <option value={'BASICA'}>BÁSICA</option>
                )
              }
              {
                formik.values.plano
                && !['PREMIUM', 'STARTER', 'BASICA'].includes(formik.values.plano)
                && (
                  <option value={formik.values.plano}>{formik.values.plano}</option>
                )
              }
            </select>
          </div>
        </div>
      </div>

      <div className='modal-footer py-lg-10 px-lg-10'>
        <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
            <button
                type='button'
                className='btn btn-lg btn-light'
                disabled={loading}
                onClick={() => {
                    closed()
                }}
            >
                <KTSVG
                    path='/media/icons/duotune/arrows/arr063.svg'
                    className='svg-icon-3 ms-2 me-0'
                />
                <span style={{marginLeft: '0.5rem'}}>Cancelar</span>
            </button>

            <button
                type='button'
                className='btn btn-lg btn-primary'
                disabled={loading}
                onClick={submit}
            >
                Atualizar
                {
                    loading ?
                    <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                    :
                    <KTSVG
                        path='/media/icons/duotune/arrows/arr064.svg'
                        className='svg-icon-3 ms-2 me-0'
                    />
                }
            </button>
        </div>

        <ModalExportDataPrognosis
          show={showCreateAppModalExport}
          data={data}
          handleClose={() => {
            setShowCreateAppModalExport(false)
          }}
          formikUpdate={formik}
        />
      </div>
    </Modal>,
    modalsRoot
  )
}

export {ModalUpdatePrognosisPlant}
